import { useEvent } from "./useEvent";

export const getLocaleFlag = (locale: AppLocale) => {
  switch (locale) {
    case "en":
      return "🇬🇧";
    case "lt":
      return "🇱🇹";
    case "sv":
      return "🇸🇪";
    case "de":
      return "🇩🇪";
    case "es":
      return "🇪🇸";
    case "it":
      return "🇮🇹";
    case "fr":
      return "🇫🇷";
    case "pl":
      return "🇵🇱";
    case "lv":
      return "🇱🇻";
    case "pt":
      return "🇧🇷";
    case "zh":
      return "🇨🇳";
    default:
      return "🇬🇧"; // Default to english
  }
};

export const getBeginCopy = (locale: AppLocale) => {
  switch (locale) {
    case "en":
      return "Begin";
    case "lt":
      return "Pradėti";
    case "sv":
      return "Börja";
    case "de":
      return "Beginnen";
    case "es":
      return "Comenzar";
    case "it":
      return "Inizia";
    case "fr":
      return "Commencer";
    case "pl":
      return "Rozpocznij";
    case "lv":
      return "Sākt";
    case "pt":
      return "Começar";
    case "zh":
      return "开始";
    default:
      return "Begin"; // Default to english
  }
};

export const useLocales = (useAllLocales = false) => {
  const [event] = useEvent();
  const locales = event?.locales;
  const validLocales = locales
    ? (Object.keys(locales).filter((locale) => locales[locale] === true) as AppLocale[])
    : ["en"];

  if (useAllLocales) return ["en", "lt", "sv", "de", "es", "it", "fr", "pl", "lv", "pt", "zh"] as AppLocale[];

  return Array.from(new Set([...validLocales])) as AppLocale[];
};
